
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { StatsCardsRow } from '@/components/crm/StatsCardsRow';
import { QuickActionsPanel } from '@/components/crm/QuickActionsPanel';
import { OpportunitiesDashboardSection } from '@/components/crm/OpportunitiesDashboardSection';
import { RecentActivityDashboardSection } from '@/components/crm/RecentActivityDashboardSection';

const CrmDashboardPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Dashboard | Exchange CRM</title>
      </Helmet>
      <div className="space-y-6">
        <StatsCardsRow />
        <QuickActionsPanel />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <OpportunitiesDashboardSection />
          <div className="lg:col-span-1"> {/* This ensures RecentActivity takes 1/3 on large screens */}
            <RecentActivityDashboardSection />
          </div>
        </div>
      </div>
    </>
  );
};

export default CrmDashboardPage;

